export default __webpack_public_path__ + "static/media/040-barbed.f8322902.png";